import { c as _c } from "react/compiler-runtime";
import { useTranslation as useUtilTranslation } from '@systemeio/util';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionCreateUserEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import React from 'react';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getLocaleSelectOptions } from 'shared/utils/locale/get-locale-select-options';
interface ActionCreateUserItemProps extends EditActionItemInterface<ActionCreateUserEditInterface> {}
const ActionCreateUserItem = t0 => {
  const $ = _c(16);
  const {
    actions,
    action,
    errors,
    setRules,
    idx,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUtil
  } = useUtilTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.locale || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t || $[10] !== tUtil) {
    t2 = () => <><FormSelect required={true} label={t("dashboard.automation_rule.action.new_user_language")} placeholder={t("dashboard.automation_rule.choose_language_of_user")} value={action.locale} data={getLocaleSelectOptions(tUtil)} onChange={data => setRules(prev => ({
        ...prev,
        actions: actions.map((el, i) => {
          if (idx === i) {
            return {
              ...el,
              locale: data
            };
          } else {
            return el;
          }
        })
      }))} error={errors.automationActions[action.id]?.locale?.join("")} /></>;
    $[3] = action.id;
    $[4] = action.locale;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = tUtil;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== action.type || $[13] !== t1 || $[14] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[12] = action.type;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default ActionCreateUserItem;